import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	signal,
	WritableSignal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
	selector: 'cmms-year-selector',
	templateUrl: './cmms-year-selector.component.html',
	styleUrls: ['./cmms-year-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule],
})
export class CmmsYearSelectorComponent implements OnInit {
	@Input() label: string = '';
	@Input() placeholder: string = '';
	@Input() amountOfYears: number = 20;
	@Input() set value(value: Date | string) {
		const year = new Date(value).getFullYear();
		this.formControl.patchValue(year);
	}

	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() valueChange = new EventEmitter<{ date: string; year: number }>();

	years: WritableSignal<number[]> = signal([]);

	formControl = new FormControl(null);

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
		this.generateYears();
	}

	emitChange() {
		const data = {
			date: `${this.formControl.value}-01-01`,
			year: this.formControl.value,
		};
		this.valueChange.emit(data);
	}

	private generateYears() {
		const currentYear = new Date().getFullYear();
		const startYear = currentYear - this.amountOfYears;

		const years: number[] = [];
		for (let year = startYear; year <= currentYear; year++) {
			years.unshift(year);
		}
		this.years.set(years);
	}
}
